import { render, staticRenderFns } from "./userAddressPicker.vue?vue&type=template&id=8d71b170&scoped=true"
import script from "./userAddressPicker.vue?vue&type=script&lang=js"
export * from "./userAddressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71b170",
  null
  
)

export default component.exports